import { render, staticRenderFns } from "./userFollow.vue?vue&type=template&id=2f5ca64b&scoped=true&"
import script from "./userFollow.vue?vue&type=script&lang=js&"
export * from "./userFollow.vue?vue&type=script&lang=js&"
import style0 from "./userFollow.vue?vue&type=style&index=0&id=2f5ca64b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ca64b",
  null
  
)

export default component.exports